import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { ReactComponent as EditIcon } from "../../assets/Icons/edit-3.svg";
import { useCredentials } from "../../contexts/Credentials";
import { useCommon } from "../../contexts/common";
import { trackClickEvent } from "../../mixpanel";

const CredentialItem = ({ data }) => {
  const { handleOpen } = useCredentials();
  const { licensesList, fetchLicensesList } = useCommon();

  useEffect(() => {
    fetchLicensesList();
  }, []);

  const getLicenseName = (licenseTypeId) => {
    const license = licensesList?.find(
      (license) => license.id === licenseTypeId,
    );
    return license?.name || "";
  };

  const onEdit = () => {
    handleOpen(data, data?.type);
    trackClickEvent("Updated Profile Information", {
      component: `Credential ${data?.type} section`,
      page: "Edit Profile",
    });
  };

  return (
    <Box component="li" sx={{ listStyleType: "disc" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          minHeight: 30,
          ".MuiIconButton-root": {
            display: "none",
          },
          "&:hover .MuiIconButton-root": {
            display: "flex",
          },
        }}
      >
        <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
          {data?.type === "pre-license"
            ? `Supervisor: ${data?.data?.supervisor_name}\n${getLicenseName(
                data?.type_id,
              )} | ${data?.state?.name}`
            : null}
          {data?.type === "license"
            ? `${getLicenseName(data?.type_id)}\n${data?.data?.board} ${
                data?.data?.year
              } / ${data?.data?.number}, ${data?.state?.name}`
            : null}

          {data?.type === "membership" ? (
            <Typography variant="body2">
              {data?.data?.title} {data?.data?.year} / {data?.data?.number}
            </Typography>
          ) : null}
        </Typography>
        <IconButton sx={{ p: 0.375 }} onClick={onEdit}>
          <EditIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default CredentialItem;
